
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/search",
      function () {
        return require("private-next-pages/help/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/search"])
      });
    }
  